import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Coordina la apertura del buscador global. El modal (GlobalSearchComponent)
 * se renderiza una sola vez en AppComponent y escucha `open$`; los botones
 * disparadores de los navbars (desktop y mobile) llaman a `open()`.
 */
@Injectable({
  providedIn: 'root'
})
export class SearchUiService {
  private openSubject = new Subject<void>();
  open$ = this.openSubject.asObservable();

  open(): void {
    this.openSubject.next();
  }
}
